import { TPreferences } from '../preferences/preferences.model';
import { CurrentUserResponse } from './response-models/current-user-response-model';
import { TUser } from './user.model';

/* Needed to allow us to keep changes across codebase as minimal as possible with new /me endpoint */
export function mapCurrentUserToUser(currentUser: CurrentUserResponse): TUser {
  return {
    createdOn: currentUser.user.createdAt,
    activeWorkspaceId: currentUser.activeWorkspaceId,
    accountId: currentUser.activeAccountId,
    email: currentUser.user.email,
    userName: currentUser.user.name,
    userId: currentUser.user.id,
    userType: currentUser.user.type,
    avatarId: currentUser.user.avatar?.imageId ?? null,
    unreadNotifications: currentUser.notifications.unreadNotifications,
    intercomHash: currentUser.intercomHash,
    signature: currentUser.signature,
  };
}

export function mapCurrentUserToPreferences(currentUser: CurrentUserResponse): TPreferences | null {
  if (!currentUser.preferences) {
    return null;
  }

  const { dashlets, ...preferences } = currentUser.preferences;

  if (!dashlets) {
    return preferences;
  }

  return { ...preferences, dashlets: { data: dashlets } };
}
